import { PrivateInterceptor } from "../../interceptors/PrivateInterceptor";
import { PrivateInterceptorIPS } from "../../interceptors/PrivateInterceptorIPS";
import { PublicInterceptor } from "../../interceptors/PublicInterceptor";


export const getCustomers = async () => {
    const result = await PrivateInterceptor(`Base/Clientes/`, 'GET');
    return result;
}

export const getPaises = async () => {
    const result = await PrivateInterceptor(`Base/Clientes/getPaises`, 'GET');
    return result;
}

export const getInfoCustomer = async(IdCustomer) =>{
    const result = await PrivateInterceptor(`Base/Clientes/${IdCustomer}`, 'GET');
    return result;
} 

export const getInfoCustomerPorId = async(IdCustomer, token) =>{
    const result = await PublicInterceptor(`Clientes/Clientes/PorId`, 'POST', {IdCustomer}, token);
    return result;
} 


export const getUltimoIdCustomer = async() =>{
    const result = await PrivateInterceptor(`Base/Clientes/customerUltimoIdCustomer`, 'GET');
    return result;
}

//EDITAR
export const postCustomer = async(Datos) =>{
    const result = await PrivateInterceptor(`Base/Clientes/IUCustomer`, 'POST', {Datos});
    return result;
}

//AGREGAR
export const addCustomer = async(Datos) =>{
    const result = await PrivateInterceptor(`Base/Clientes/AddCustomer`, 'POST', {Datos});
    return result;
}

export const putChecksCustomer = async (body) =>{
    
    const result = await PrivateInterceptor(`Base/Clientes/checkCustomer`, 'PUT', body);
    return result;
}


// OBTENER ENLACE DE INSCRIPCION DE UN Cliente
export const getEnlaceInscripcion = async (IdCustomer, IdUser, Finanzas) => {
    // console.log(Finanzas)
    const result = await PrivateInterceptor(`Base/Clientes/LinkInscripcion`, 'POST', {IdCustomer, IdUser, Finanzas});
    return result;
}

// OBTIENE TODA LA INFORMACION DE LOS PRODUCTOS
export const getTipoPagoCliente = async (token) => {
    const respuesta = PublicInterceptor('Base/Clientes/TipoPagoCliente', 'GET', {}, token)
    return respuesta
};

//************************************** CUSTOMER DETAILS ************************************** */

export const getALLCustomersDetails = async () => {
    
    const result = await PrivateInterceptor(`Base/Clientes/customerDetails`, 'GET');
    return result;

}

export const getCustomerDetails = async(IdCustomer) =>{
    const result = await PrivateInterceptor(`Base/Clientes/customerDetails/${IdCustomer}`, 'GET');
    return result;
}


export const getCustomerDetailsIPS = async(IdCustomer) =>{
    const result = await PrivateInterceptor(`Base/Clientes/getCustomerDetailsIPS/${IdCustomer}`, 'GET');
    return result;
}

export const getUltimoIdCustomerDetails = async() =>{
    const result = await PrivateInterceptor(`Base/Clientes/customerDetailsUltimoId`, 'GET');
    return result;
}


export const postCustomerDetails = async (data) =>{
    const result = await PrivateInterceptor(`Base/clientes/IUCustomerDetails`, 'POST', data);
    return result;
}


export const putChecksCustomerDetails = async (body) =>{
    
    const result = await PrivateInterceptor(`Base/clientes/checkCustomerDetails`, 'PUT', body);
    return result;
}



export const putStatusCustomerDetails = async (data) =>{
    const result = await PrivateInterceptor(`Base/clientes/cambiarEstadoCustomerDetails`, 'PUT', data);
    return result;
}


export const BlockCustomerIPS = async (data) => {
    
    const result = await  PrivateInterceptorIPS(`Customers/BlockCustomer`, 'POST', data);
    return result;
}

// ACTUALIZAR ESTADO DE EDICION DEL ENLACE DE INSCRIPCION DEL PROVEEDOR 
export const cambiarEstadoCustomerD = async (IdStatus, Ids) => {
    const result = await PrivateInterceptor(`Base/Clientes/cambiarEstadoCustomerD`, 'POST', {IdStatus, Ids});
    return result;
}

// ACTUALIZAR ESTADO DE EDICION DEL ENLACE DE INSCRIPCION DEL PROVEEDOR 
export const cambiarCountry = async (IdCountry, Ids) => {
    const result = await PrivateInterceptor(`Base/Clientes/cambiarCountry`, 'POST', {IdCountry, Ids});
    return result;
}


// OBTENER INFORMACION DE UN CLIENTE
export const getInfoCliente = async (IdCustomer, token) => {
    const result = await PublicInterceptor(`Base/Clientes/getCliente`, 'POST', {IdCustomer}, token );
    return result;
}

// OBTENER INFORMACION DE UN CLIENTE
export const getInfoClientePorId = async (IdCustomer, token) => {
    const result = await PublicInterceptor(`Base/Clientes/getCliente`, 'POST', {IdCustomer}, token );
    return result;
}

// OBTENER INFORMACION DE UN CLIENTE
export const getAccionistas = async (IdCustomer, token) => {
    const result = await PublicInterceptor(`Base/Clientes/getAccionistas`, 'POST', {IdCustomer}, token );
    return result;
}

// OBTENER INFORMACION DE UN CLIENTE
export const getAccionistasPorId = async (IdCustomer, token) => {
    const result = await PublicInterceptor(`Base/Clientes/getAccionistas`, 'POST', {IdCustomer}, token );
    return result;
}

// OBTENER DIRECTORES
export const getDirectores = async (IdCustomer, token) => {
    const result = await PublicInterceptor(`Base/Clientes/getDirectores`, 'POST', {IdCustomer}, token );
    return result;
}

// OBTENER DIRECTORES
export const getDirectoresPorId = async (IdCustomer, token) => {
    const result = await PublicInterceptor(`Base/Clientes/getDirectores`, 'POST', {IdCustomer}, token );
    return result;
}

// GUARDAR INSCRIPCION
export const GuardarInscripcion = (Datos, token) => {
    const respuesta = PublicInterceptor("Base/Clientes/AgregarCustomerInfo", "POST", {Datos}, token);
    return respuesta;
};

// GUARDAR Accionistas
export const GuardarAccionistas = (Datos, token) => {
    const respuesta = PublicInterceptor("Base/Clientes/AgregarAccionista", "POST", {Datos}, token);
    return respuesta;
};

// GUARDAR DIRECTORES
export const GuardarDirectores = (Datos, token) => {
    const respuesta = PublicInterceptor("Base/Clientes/AgregarDirector", "POST", {Datos}, token);
    return respuesta;
};

export const guardarNombreFormato = async(Datos, Token) =>{
    const result = await PublicInterceptor(`Base/Clientes/guardarNombreFormato`, 'POST', Datos, Token);
    return result;
}

export const eliminarNombreFormato = async(Datos, Token) =>{
    const result = await PublicInterceptor(`Base/Clientes/eliminarNombreFormato`, 'POST', Datos, Token);
    return result;
}


export const GuardarCustomerDetails = async (Datos) => {
    const result = await  PrivateInterceptor(`Base/Clientes/GuardarCustomerDetails`, 'POST', {Datos});
    return result;
}
// Actualizar el correo para enviar el estado de cuenta de cobro del cliente
export const postEditarCorreCobroCliente = async(informacion) =>{
    const result = await  PrivateInterceptor(`Base/Clientes/cambiarCorreoCobro`, 'POST', informacion);
    return result;
}

// -------------------------------------------------REPRESENTANTE---------------------------------------------------------------------------------

export const getArchivoRepresentante = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Representante/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoRepresentante= async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Representante/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}


export const eliminarArchivoRepresentante = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Representante/deleteFile/${Codigo}`, 'DELETE', {nombre}, Token)
    return respuesta;
}

// -------------------------------------------------REFERENCIA COMERCIAL 1---------------------------------------------------------------------------------

export const getArchivoRefComercial1 = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/RefComercial1/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoRefComercial1= async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/RefComercial1/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}


export const eliminarArchivoRefComercial1 = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/RefComercial1/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta;
}

// -------------------------------------------------REFERENCIA fComercial1---------------------------------------------------------------------------------

export const getArchivoRefComercial2 = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/RefComercial2/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoRefComercial2= async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/RefComercial2/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}


export const eliminarArchivoRefComercial2 = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/RefComercial2/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta;
}

  

// --------------------------------------------------ARCHIVOS BIC------------------------------------------------------------------------------------

export const getArchivosBIC = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/BIC/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

  export const descargarArchivoBIC = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/BIC/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}

  export const eliminarArchivoBIC = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/BIC/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta;
}

// --------------------------------------------------ARCHIVOS FACTURA------------------------------------------------------------------------------------

export const getArchivosFactura = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Factura/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoFactura = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Factura/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}

export const eliminarArchivoFactura = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Factura/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta;
}

// --------------------------------------------------ARCHIVOS PERMISO------------------------------------------------------------------------------------

export const getArchivosPermiso = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Permiso/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoPermiso = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Permiso/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}

export const eliminarArchivoPermiso = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Permiso/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta;
}

// --------------------------------------------------ARCHIVOS PERMISO------------------------------------------------------------------------------------

export const getArchivosEscritura = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Escritura/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoEscritura = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Escritura/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}

export const eliminarArchivoEscritura = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Escritura/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta;
}


// --------------------------------------------------ARCHIVOS CONSTANCIA------------------------------------------------------------------------------------

export const getArchivosConstancia = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Constancia/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoConstancia = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Constancia/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}

export const eliminarArchivoConstancia = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Constancia/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta;
}


// --------------------------------------------------ARCHIVOS REGISTRO------------------------------------------------------------------------------------

export const getArchivosRegistro = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Registro/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoRegistro = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Registro/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}

export const eliminarArchivoRegistro = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Registro/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta;
}
  


// --------------------------------------------------ARCHIVOS ESTADOS------------------------------------------------------------------------------------

export const getArchivosEstados = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Estados/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoEstados = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Estados/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}

export const eliminarArchivoEstados= async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/Estados/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta;
}
  


// ACTUALIZAR ESTADO DE EDICION DEL ENLACE DE INSCRIPCION DEL PROVEEDOR 
export const updateEnlaceInscripcion = async (body) => {
    const result = await PrivateInterceptor(`Base/Clientes/actualizarEstadoEdicion`, 'PUT', body);
    return result;
}

export const ocultarClienteVentas = async (body) => {
    const result = await PrivateInterceptor(`Base/Clientes/ocultarClienteVentas`, 'POST', body);
    return result;
}

// ACTUALIZAR ESTADO DE EDICION DEL ENLACE DE INSCRIPCION DEL PROVEEDOR 
export const updateClienteNuevo = async (body) => {
    const result = await PrivateInterceptor(`Base/Clientes/actualizarClienteNuevo`, 'PUT', body);
    return result;
}


// -------------------------------------------------REFERENCIA BANCARIAS 1---------------------------------------------------------------------------------

export const getArchivoRefBan1 = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/RefBanc1/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoRefBan1= async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/RefBanc1/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}


export const eliminarArchivoRefBan1 = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/RefBanc1/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta;
}

// -------------------------------------------------REFERENCIA BANCARIAS 2---------------------------------------------------------------------------------

export const getArchivoRefBan2 = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/RefBanc2/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoRefBan2= async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/RefBanc2/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}


export const eliminarArchivoRefBan2 = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/RefBanc2/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta; 
}

// -------------------------------------------------CERTIFICADO AMBIENTAL---------------------------------------------------------------------------------

export const getArchivoCertificadoA = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/CertificadoAmbiental/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoCertificadoA= async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/CertificadoAmbiental/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}

export const eliminarArchivoCertificadoA = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/CertificadoAmbiental/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta;
}

// -------------------------------------------------CERTIFICADO AMBIENTAL---------------------------------------------------------------------------------

export const getArchivoCertificadoL = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/CertificadoLaboral/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoCertificadoL = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/CertificadoLaboral/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}

export const eliminarArchivoCertificadoL = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/CertificadoLaboral/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta;
}

// -------------------------------------------------FORMATO DE INSCRIPCION---------------------------------------------------------------------------------

export const getArchivoFormatoInscripcion = async(Codigo, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/FormatoInscripcion/getTest/` + Codigo, 'GET', {}, Token)
    return respuesta;
}

export const descargarArchivoFormatoInscripcion = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/FormatoInscripcion/getFile/${Codigo}`, 'POST', {nombre} , Token)
    return respuesta;
}

export const eliminarArchivoFormatoInscripcion = async (Codigo, nombre, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/FormatoInscripcion/deleteFile/${Codigo}`, 'DELETE', {nombre} , Token)
    return respuesta;
}

export const postChangeEstadoClientes = async (data) => {
    const result = await PrivateInterceptor(`Base/Clientes/chageEstadoClientes`, 'POST', data);
    return result;
}

export const DescargarManual = async (idioma, Token) => {
    const respuesta = await PublicInterceptor(`Base/Clientes/DescargarManual`, 'POST', {idioma} , Token)
    return respuesta;
}

//------------------------------------------------------------------------- CONVENIO --------------------------------------------------------------------------------------


export const ObtenerConvenioCliente = async (IdCustomer) => {
    const result = await PrivateInterceptor( `Base/Clientes/Convenio/ObtenerConvenioCliente`, "POST", { IdCustomer });
    return result;
};

export const ObtenerSiguienteCorrelativo = () => {
    const respuesta = PrivateInterceptor("Base/Clientes/Convenio/ObtenerSiguienteCorrelativo", "GET");
    return respuesta;
};


export const GuardarConvenio = async (Datos) => {
    const respuesta = PrivateInterceptor("Base/Clientes/Convenio/GuardarConvenio", "POST",{Datos});
    return respuesta;
};

export const EditarConvenio = async (Datos) => {
    const respuesta = PrivateInterceptor("Base/Clientes/Convenio/EditarConvenio", "POST",{Datos});
    return respuesta;
};

export const CambiarEstadoInscripcion = (Datos, token) => {
    const respuesta = PublicInterceptor("Base/Clientes/ActualizarEstadoInscripcion", "POST", {Datos}, token);
    return respuesta;
};

